export { passwordStrengthLevel } from './password';
export { apiManagerRequest } from './apiManagerRequest';
export { getProvinceAndLocalityName } from './getProvinceAndLocalityName';
export { getTypeModalState } from './getTypeModalState';
export { getButtonsModalByCode } from './getButtonsModalByCode';
export { getDeviceId } from './getDeviceId';
export { getBrowser } from './getBrowser';
export { getAgeByUnixTimeStamp } from './getAgeByUnixTimeStamp';
export { getTokenAuthStorage } from './getTokenAuthStorage';